<mat-card>
  <div class="eula-main-container">
    <div class="header">
      <img priority="5" ngSrc="{{ image }}" height="128" width="239" alt="elitment image" />
    </div>

    <div class="eula-container eula-en">
      <div class="eula-title" (click)="onTitleClicked('EN')">
        {{ eulaTitleEn }}
        <mat-icon class="eula-icon">{{ isEulaEnOpened ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
      </div>
      <div class="eula" [ngClass]="isEulaEnOpened ? 'eula-opened' : 'eula-closed'" >
        <p><i>This is an unofficial English translation of the Terms of Use. Only the original French version is legally binding and authoritative.</i></p>
    
        <b>1. Acceptance of Terms</b>
        <br>
        <span>By using Elitment Performance, you agree to these Terms of Use and our <a href="./privacy-terms">Privacy Policy</a>. If you do not accept these terms, you may not use our application.</span>
        <br><br>
      
        <b>2. License of Use</b>
        <br>
        <span>We grant you a limited, personal, non-exclusive, non-transferable, and revocable license to access and use Elitment Performance in accordance with these terms.</span>
        <br><br>
      
        <b>3. User Responsibilities</b>
        <br>
        <span>You agree to:</span>
        <ul>
          <li>Use the application only for lawful purposes and in compliance with these terms.</li>
          <li>Maintain the confidentiality of your login credentials.</li>
          <li>Not share or sell your access credentials to third parties.</li>
        </ul>
      
        <b>4. Data Usage</b>
        <br>
        <span>Your data is collected and processed in accordance with our Privacy Policy. By using the application, you consent to us storing and processing your data to improve our services. <br><br>
        <b>Localized Processing</b>: The collected data may be stored in Switzerland or in third countries that comply with applicable regulations (such as GDPR for the EU).</span>
        <br><br>
      
        <b>5. Intellectual Property</b>
        <br>
        <span>All content, features, and graphic elements of Elitment Performance are protected by intellectual property laws. You may not reproduce, distribute, or modify the application without prior authorization.</span>
        <br><br>
      
        <b>6. Limitation of Liability</b>
        <br>
        <span>We strive to provide a reliable service. However, we do not guarantee that the application will always be error-free or uninterrupted. We disclaim any liability for losses or damages arising from the use of the application.</span>
        <br><br>
      
        <b>7. Termination</b>
        <br>
        <span>We reserve the right to suspend or terminate your access to the application in case of non-compliance with these terms.</span>
        <br><br>
      
        <b>8. Modification of Terms</b>
        <br>
        <span>We may modify these terms at any time. You will be informed of the changes before they take effect and will need to accept the new terms to continue using the application.</span>
        <br><br>
      
        <b>9. Applicable Law and Jurisdiction</b>
        <br>
        <span>These terms are governed by Swiss law. Any dispute relating to their interpretation or enforcement will be subject to the competent courts of the Canton of Valais.</span>
        <br><br>
      
        <b>10. Contact</b>
        <br>
        <span>For any questions or requests regarding these terms, you can contact us at <a href="mailto:info@elitment.com">info&#64;elitment.com</a>.</span>    
      </div>
    </div>
    <div class="separator"></div>
    <div class="eula-container eula-fr">
      <div class="eula-title" (click)="onTitleClicked('FR')">
        {{ eulaTitleFr }}
        <mat-icon class="eula-icon">{{ isEulaFrOpened ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
      </div>
      <div class="eula" [ngClass]="isEulaFrOpened ? 'eula-opened' : 'eula-closed'" >
        <b>1. Acceptation des conditions</b>
        <br>
        <span>En utilisant Elitment Performance, vous acceptez les présentes Conditions d'utilisation et notre <a href="./privacy-terms">Politique de confidentialité</a>. Si vous n'acceptez pas ces conditions, vous ne pouvez pas utiliser notre application.</span> 
        <br><br>
        <b>2. Licence d'utilisation</b>
        <br>
        <span>Nous vous accordons une licence limitée, personnelle, non exclusive, non transférable et révocable pour accéder et utiliser Elitment Performance conformément aux présentes conditions.</span>
        <br><br>
        <b>3. Responsabilités de l'utilisateur</b>
        <br>
        <span>Vous vous engagez à :</span>
        <ul>
          <li>Utiliser l'application uniquement à des fins légales et conformément aux présentes conditions.</li>
          <li>Assurer la confidentialité de vos identifiants de connexion.</li>
          <li>Ne pas partager ou vendre vos accès à des tiers.</li>
        </ul>
        <b>4. Utilisation des données</b>
        <br>
        <span>Vos données sont collectées et traitées conformément à notre Politique de confidentialité. En utilisant l'application, vous consentez à ce que nous stockions et traitions vos données pour améliorer nos services. <br><br> <b>Traitement localisé</b> : Les données collectées peuvent être stockées en Suisse ou dans des pays tiers respectant les réglementations applicables (comme le RGPD pour l'UE).</span>
        <br><br>
        <b>5. Propriété intellectuelle</b>
        <br>
        <span>Tous les contenus, fonctionnalités et éléments graphiques de Elitment Performance sont protégés par les lois sur la propriété intellectuelle. Vous ne pouvez pas reproduire, distribuer ou modifier l'application sans autorisation préalable.</span>
        <br><br>
        <b>6. Limitation de responsabilité</b>
        <br>
        <span>Nous nous efforçons de fournir un service fiable. Cependant, nous ne garantissons pas que l'application sera toujours exempte d'erreurs ou d'interruptions. Nous déclinons toute responsabilité en cas de pertes ou de dommages découlant de l'utilisation de l'application.</span>
        <br><br>
        <b>7. Résiliation</b>
        <br>
        <span>Nous nous réservons le droit de suspendre ou de résilier votre accès à l'application en cas de non-respect des présentes conditions.</span>
        <br><br>
        <b>8. Modification des conditions</b>
        <br>
        <span>Nous pouvons modifier ces conditions à tout moment. Vous serez informé(e) des changements avant leur entrée en vigueur et devrez accepter les nouvelles conditions pour continuer à utiliser l'application.</span>
        <br><br>
        <b>9. Loi applicable et juridiction compétente</b>
        <br>
        <span>Ces conditions sont régies par le droit suisse. Tout litige relatif à leur interprétation ou leur exécution sera soumis aux tribunaux compétents du canton du Valais</span>
        <br><br>
        <b>10. Contact</b>
        <br>
        <span>Pour toute question ou demande concernant ces conditions, vous pouvez nous contacter à <a href="mailto:info@elitment.com">info&#64;elitment.com</a>.</span>
      </div>
    </div>
    <div class="separator"></div>
    <div class="eula-container eula-it">
      <div class="eula-title" (click)="onTitleClicked('IT')">
        {{ eulaTitleIt }}
        <mat-icon class="eula-icon">{{ isEulaItOpened ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
      </div>
      <div class="eula" [ngClass]="isEulaItOpened ? 'eula-opened' : 'eula-closed'" >
        <p><i>Questa è una traduzione non ufficiale in italiano delle Condizioni d'Uso. Solo la versione originale in francese ha valore legale e fa fede ufficialmente.</i></p>
    
        <b>1. Accettazione delle condizioni</b>
        <br>
        <span>Utilizzando Elitment Performance, accetti le presenti Condizioni d'Uso e la nostra <a href="./privacy-terms">Informativa sulla Privacy</a>. Se non accetti tali condizioni, non puoi utilizzare la nostra applicazione.</span>
        <br><br>
      
        <b>2. Licenza d'uso</b>
        <br>
        <span>Ti concediamo una licenza limitata, personale, non esclusiva, non trasferibile e revocabile per accedere e utilizzare Elitment Performance in conformità con le presenti condizioni.</span>
        <br><br>
      
        <b>3. Responsabilità dell'utente</b>
        <br>
        <span>Ti impegni a:</span>
        <ul>
          <li>Utilizzare l'applicazione esclusivamente per scopi legali e in conformità con le presenti condizioni.</li>
          <li>Mantenere la riservatezza delle tue credenziali di accesso.</li>
          <li>Non condividere né vendere le tue credenziali di accesso a terzi.</li>
        </ul>
      
        <b>4. Utilizzo dei dati</b>
        <br>
        <span>I tuoi dati vengono raccolti e trattati in conformità con la nostra Informativa sulla Privacy. Utilizzando l'applicazione, acconsenti alla conservazione e al trattamento dei tuoi dati per migliorare i nostri servizi. <br><br>
        <b>Trattamento localizzato</b>: I dati raccolti possono essere conservati in Svizzera o in paesi terzi che rispettano le normative applicabili (come il GDPR per l'UE).</span>
        <br><br>
      
        <b>5. Proprietà intellettuale</b>
        <br>
        <span>Tutti i contenuti, le funzionalità e gli elementi grafici di Elitment Performance sono protetti dalle leggi sulla proprietà intellettuale. Non puoi riprodurre, distribuire o modificare l'applicazione senza autorizzazione preventiva.</span>
        <br><br>
      
        <b>6. Limitazione di responsabilità</b>
        <br>
        <span>Facciamo del nostro meglio per fornire un servizio affidabile. Tuttavia, non garantiamo che l'applicazione sia sempre priva di errori o interruzioni. Decliniamo ogni responsabilità per eventuali perdite o danni derivanti dall'uso dell'applicazione.</span>
        <br><br>
      
        <b>7. Cessazione</b>
        <br>
        <span>Ci riserviamo il diritto di sospendere o terminare l'accesso all'applicazione in caso di violazione delle presenti condizioni.</span>
        <br><br>
      
        <b>8. Modifica delle condizioni</b>
        <br>
        <span>Possiamo modificare queste condizioni in qualsiasi momento. Sarai informato/a delle modifiche prima della loro entrata in vigore e dovrai accettare le nuove condizioni per continuare a utilizzare l'applicazione.</span>
        <br><br>
      
        <b>9. Legge applicabile e foro competente</b>
        <br>
        <span>Le presenti condizioni sono regolate dal diritto svizzero. Qualsiasi controversia relativa alla loro interpretazione o esecuzione sarà sottoposta ai tribunali competenti del Cantone del Vallese.</span>
        <br><br>
      
        <b>10. Contatto</b>
        <br>
        <span>Per qualsiasi domanda o richiesta riguardante queste condizioni, puoi contattarci all'indirizzo <a href="mailto:info@elitment.com">info&#64;elitment.com</a>.</span>    
      </div>
    </div>
  </div>
</mat-card>
